import { Layout, Menu, MenuProps, Popconfirm, theme } from "antd";
import React, { useEffect, useState } from "react";
import "./AdminLayout.css";
import {
  UserOutlined,
  DatabaseOutlined,
  LogoutOutlined,
  DesktopOutlined,
  SettingOutlined,
  ToolOutlined,
  BulbOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { onLogout } from "../API/RequireAuth";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useAppRole, useUserRole } from "../API/RoleContext";
import {
  CopyAllOutlined,
  DashboardOutlined,
  FolderOpenOutlined,
  GroupOutlined,
  CloudOutlined,
  MailOutlined,
} from "@mui/icons-material";

const { Header, Sider, Content } = Layout;
type AdminLayoutProps = {
  children: React.ReactNode; // Define the children prop
};
type MenuItem = Required<MenuProps>["items"][number];
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const userRole = useUserRole();
  const appRole = useAppRole();
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const navigate = useNavigate();
  const location = useLocation();
  const paramValue = location.pathname.split("/").pop() ?? "";
  const [selectedMenuItem, setSelectedMenuItem] = useState<string>(paramValue);
  useEffect(() => {
    setCurrent(selectedMenuItem);
    let newOpenKeys: any = [];

    switch (selectedMenuItem) {
      case "software-dashboard":
      case "license-management":
      case "server-license":
        newOpenKeys = ["licensemanagement"];
        break;
      case "reports":
        newOpenKeys = ["rep"];
        break;
      case "email-list":
      case "email-groups":
      case "email-dashboard":
      case "special-emails":
        newOpenKeys = ["sub4"];
        break;
      case "designation":
      case "device":
      case "domain":
      case "configuration":
        newOpenKeys = ["sub3"];
        break;

      default:
        newOpenKeys = [];
        break;
    }

    setOpenKeys(newOpenKeys);
  }, [selectedMenuItem]);

  function getItem(
    label: React.ReactNode,
    key: React.Key,

    icon?: React.ReactNode,
    children?: MenuItem[]
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
    } as MenuItem;
  }
  const items: MenuItem[] = [
    getItem("Software License", "licensemanagement", <CopyAllOutlined />, [
      getItem("Dashboard", "software-dashboard", <DashboardOutlined />),
      getItem("Manage", "license-management", <ToolOutlined />),
      getItem("Server License", "server-license", <CloudOutlined />),
      // getItem("Report", "reports", <DatabaseOutlined />),
    ]),

    getItem("Email License", "sub4", <MailOutlined />, [
      getItem("Dashboard", "email-dashboard", <DashboardOutlined />),
      getItem("Manage", "email-list", <ToolOutlined />),
      getItem("Groups", "email-groups", <GroupOutlined />),
      getItem("Special Emails", "special-emails", <MailOutlined />),
    ]),
    getItem("Reports", "rep", <DatabaseOutlined />, [
      getItem("Software", "reports", <DatabaseOutlined />),
    ]),
    getItem("Settings", "sub3", <ToolOutlined />, [
      getItem("Designation", "designation", <SolutionOutlined />),
      getItem("Software", "configuration", <ToolOutlined />),
      getItem("Device", "device", <DesktopOutlined />),
      getItem("Domain", "domain", <ToolOutlined />),
      // getItem("Man", "domain", <ToolOutlined />),
    ]),
    getItem("Admin Management", "admin-management", <ToolOutlined />),
    getItem("Approval", "approvals", <FolderOpenOutlined />),
    getItem("Pending", "pending", <FolderOpenOutlined />),
  ];

  const filteredItems = items.filter(
    (item: any) =>
      (item.key !== "admin-management" || userRole.includes("Manager")) &&
      (item.key !== "pending" || appRole === "Sub-Admin") &&
      (item.key !== "approvals" || appRole === "Admin") &&
      (item.key !== "sub3" || appRole === "Admin" || appRole === "")
    // &&
    // (item.key !== 'email-groups' || (appRole === 'Admin' || appRole === ''))
  );

  const filteredItems1 = filteredItems.map((item: any) => {
    // Check if the item is a submenu and has children
    if (item.children && item.children.length > 0) {
      // Check if the userRole is not 'Manager'
      if (appRole === "Sub-Admin") {
        // Remove the submenu item with key 'skill-list'
        item.children = item.children.filter(
          (item1: any) => item1.key !== "email-groups"
        );
      }
    }
    return item;
  });

  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState(paramValue);
  const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const openChangeMenu: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  const onLogoutHandler = () => {
    onLogout();
    navigate(`/login`, { replace: true });
  };
  const token: string | null = localStorage.getItem("token");

  let username: any;
  if (token) {
    username = jwtDecode(token as string);
  }
  const usernameValue = username?.EmployeeName;

  const onClick: MenuProps["onClick"] = (e) => {
    setSelectedMenuItem(e.key.toString());
    navigate(`/${e.key}`, { replace: true });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 9,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
        className="header-top"
      >
        <div className="pm-brand"></div>
        <div className="logout-section">
          <p className="logout">
            <UserOutlined />{" "}
            <span style={{ paddingRight: "10px" }}>{usernameValue}</span>
            <Popconfirm
              style={{ boxSizing: "unset" }}
              title="Are you sure you want to logout?"
              onConfirm={() => onLogoutHandler()}
            >
              {" "}
              <LogoutOutlined
                className="logout-icon"
                style={{ paddingRight: "6px" }}
              />
            </Popconfirm>
          </p>
        </div>
      </Header>
      <Layout>
        <Sider
          width={200}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          style={{ background: colorBgContainer }}
        >
          <h3 className="headSider"></h3>
          <Menu
            openKeys={openKeys}
            selectedKeys={[current]}
            onOpenChange={openChangeMenu} // Specify the key of the parent menu item
            onClick={onClick}
            mode="inline"
            items={filteredItems1}
          />
        </Sider>
        <Layout style={{ padding: "0" }}>
          <Content
            style={{
              paddingLeft: "10px",
              margin: 0,
              minHeight: 280,
            }}
          >
            {children}
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
